import { render, staticRenderFns } from "./section-dept.vue?vue&type=template&id=b1ba285e&"
import script from "./section-dept.vue?vue&type=script&lang=js&"
export * from "./section-dept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports